module.exports = __webpack_public_path__ + "img/old_act.98e0e39a.png";